import { AppAPI } from "../../api/AppApi.js";
import { AppDataService } from "../AppDataService.js";
import { objectAssignWithOverride } from "../utils.js";
import { HttpService } from "./HttpService.js";

export class AppHttpService extends AppDataService {
    constructor(req, conf, gudhub) {
      super(req, conf, gudhub);
  
      this.appApi = new AppAPI(req);

      let httpService = new HttpService(conf);
    
      objectAssignWithOverride(this, httpService);
    }


    // TODO getApp -> getAppAndProcessData
    async getApp(id) {
        let sentData = await this.appApi.getApp(id);
        return this.processRequestedApp(id, sentData);
    }


    // TODO -> getApp
    async getAppWithoutProcessing(id) {
        return this.appApi.getApp(id);
    }

    async putApp(id, app) {
        // do nothing
    }
  
    static [Symbol.hasInstance](instance) {
        try {
            if (instance instanceof AppHttpService) return true;
            if (instance instanceof HttpService) return true; //TODO requires multiple inheritance, thhink how to overcome it
            return false;
        } catch (error) {
            return false;
        }
    }
};